<template>
  <div class="box">
    <div class="stesp-box">
      <el-steps direction="vertical" :active="stepIndex">
        <el-step v-for="(item,index) in step" :key="index">
          <template slot="description">
            <div class="title-step">{{item.name}}</div>
            <div class="item-List">
              <div class="item-wrappper">
                <div v-for="(itm,ind) in item.assignData" :key="ind" class="item-name" @click="delPerson(index,ind,item.isEditAssign)">
                  {{itm.name | nameFilter}}
                  <div class="icon-wrappper" v-if="item.isEditAssign === '1'">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
                <div class="item" v-if="item.isEditAssign == '1'">
                  <i class="el-icon-circle-plus-outline add" @click="choosePerson(index,item)"></i>
                </div>
              </div>
            </div>
          </template>
        </el-step>
      </el-steps>
      <dynamic-data-box
        :value="[]"
        v-if="flag"
        :props='{ label: "name", value: "id"}'
        :tableColumn="tableColumn"
        hostUrl="/billApprovalHr/selectUserDatas"
        :extendParms="params"
        @confirm="val => { getContent(val) }"
        :trigger="{type:'step'}"
        ref="dynamicDataBox"
      ></dynamic-data-box>
    </div>
    <div class="button">
      <el-button class="btn-submit" @click="submit" :loading="loadActivitySubmit">提交</el-button>
      <el-button class="btn-cancel" @click="cancel">取消</el-button>
    </div>
  </div>
</template>
<script>
import DynamicDataBox from "@/components/dynamic-form/dynamic-data-box";
// import { selectUserDatas } from "@/api/hrApproval";
export default {
  name: "",
  components: { DynamicDataBox },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectIndex: 0,
      step: [],
      value: [],
      tableData: [],
      loadActivitySubmit: false,
      tableColumn: [
        {
          property: "code",
          label: "编码"
        },
        {
          property: "name",
          label: "名称",
          query: { type: "input" }
        }
      ],
      selectData: [],
      form: {},
      params: {from: '',taskKey: ''},
       flag: false,
       formFlag: ''
    };
  },
  watch: {
    data: {
      handler(val) {
        this.step = val;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    stepIndex() {
      return this.step.length || 0
    }
  },
  created() {
    const name =  this.$route.name
    // from标识
    if (name === 'TaskForm') {
       this.formFlag = 'Budget_task'
    } else if (name === 'ContractForm') {
      this.formFlag = 'contract'
    } else if (name === 'DeliveryForm') {
       this.formFlag = 'project_req'
    } else if (name === 'ResourceUseFrom') {
       this.formFlag = 'Resource_use'
    } else if (name === 'RiskForm') {
       this.formFlag = 'risk'
    } else if (name === 'followupFormForm') {
       this.formFlag = 'followupForm'
    } else if (name === 'summaryForm') {
       this.formFlag = 'applicationForm_affirm'
    } else if (name === 'counselorForm') {
       this.formFlag = 'followupForm_affirm'
    } else if (name === 'applicationFormForm') {
       this.formFlag = 'applicationForm'
    } else if (name === 'InvoiceForm') {
       this.formFlag = 'moai'
    } else if (name === 'ReceiptForm') {
       this.formFlag = 'receipt'
    } else if (name === 'ReimburseForm') {
       this.formFlag = 'reimbursement'
    }
  },
  methods: {
    choosePerson(index,item) {
      this.selectIndex = index
      this.value = this.step[this.selectIndex].value
      this.params = {from: this.formFlag,taskKey: item.key}
       this.flag =  true
       setTimeout(() => {
          this.$refs.dynamicDataBox.open();
       },500)
      // selectUserDatas({from: 'project_req',taskKey: item.key}).then(res => {
      //   this.selectData =  res.data.records;
      //    this.$refs.dynamicDataBox.open();
      // })
    },
    cancel() {
      this.$emit("close");
    },
    getContent(val) {
      this.$set(this.step[this.selectIndex], 'assignData', val)
    },
    delPerson(index, ind,item) {
      if (item !== '1') {
        return
      }
      this.step[index].assignData.splice(ind, 1);
    },
    submit() {
      this.loadActivitySubmit = true;
      if (!this.checkData()) {
         this.loadActivitySubmit = false;
        return;
      }
      this.$emit("submit", this.step,(res) => {
        this.loadActivitySubmit = false;
      });
    },
    checkData() {
      let flag = true;
      const arr = this.step;
      arr.forEach((item, index) => {
        if (item.assignData.length === 0) {
          this.$notify({
            title: `请选择第${index + 1}个节点‘${item.name}’审批人`,
            type: "error",
            duration: 2500
          });
          flag = false
          return flag;
        }
      })
      return flag;
      //  for (let i = 0; i < arr.length; i++) {
      //    console.log(arr[i])
      //    if (arr[i].assignData.length === 0) {
      //       this.$notify({
      //       title: `请选择第${i + 1}个节点‘${arr[i].name}’审批人`,
      //       type: "error",
      //       duration: 2500
      //     });
      //     flag = false
      //     return flag;
      //    }
      //    return flag
      // }
    }
  },
  filters: {
    nameFilter(val) {
      return val.length > 2 ? val.substr(val.length - 2) : val;
    }
  }
};
</script>
<style lang='scss' scoped>
.step-box {
  width: 100%;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  .step-right {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 26px;
    cursor: pointer;
    i {
      position: absolute;
      top: -2px;
      right: 0;
      line-height: 37px;
      font-size: 40px;
    }
    .step-right-person {
      display: flex;
      position: absolute;
      right: 43px;
      .person {
        position: relative;
        font-size: 14px;
        width: 37px;
        height: 37px;
        line-height: 37px;
        text-align: center;
        border-radius: 18px;
        background: #4e7be4;
        color: white;
        margin-right: -5px;
        &person:last-child {
          margin-right: unset;
        }
        i {
          color: red;
          font-size: 16px;
          position: absolute;
          top: -12px;
          right: 0px;
        }
      }
    }
  }
}
.button {
  padding-top: 20px;
  text-align: right;
  .btn-submit {
    width: 80px;
    height: 38px;
    background: #1369a8;
    color: white;
  }
  .btn-cancel {
    width: 80px;
    height: 38px;
    background: #fff;
  }
}
/deep/ .el-steps--vertical{
  padding: 10px;
}
/deep/ .el-step.is-vertical .el-step__main{
  position: relative;
  width: 100%;
  height: 80px;
}
/deep/ .el-step__description.is-finish{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
.title-step{
  padding: 7px 0;
  font-size: 16px;
  font-weight: 600
}
.item-List{
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  .item-wrappper{
    display: flex;
    .item-name{
      width: 45px;
      height: 45px;
      border-radius: 50%;
      background: #1369a8;
      color: #fff;
      position: relative;
      line-height: 45px;
      text-align: center;
      font-size: 15px;
      margin-right: 5px;
      .icon-wrappper{
        color: #fff;
        font-size: 16px;
        position: absolute;
        top: 0;
        right: 0;
        width: 15px;
        height: 15px;
        background: red;
        border-radius: 50%;
        i {
          font-size: 10px;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          line-height: 15px;
        }
      }
    }
    .item{
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 50px;
      .add {
        font-size: 50px
      }
    }
  }
}
/* .item-List{
  position: relative;
  width: 100%;
  height: 80px;
  .item-wrappper{
    display:flex;
    .item{
      flex: 0 0 80px;
      height: 80px;
      position: relative;
      .add{
        position: absolute;
        top: -2px;
        right: 0;
        line-height: 37px;
        font-size: 40px;
      }
      .el-icon-remove{
        color: red;
        font-size: 16px;
        position: absolute;
        top: -12px;
        right: 0px;
      }
    }
  }
} */
</style>
